import { SetCenterIcon } from './SetCenterIcon';

/**
 * author: Simran
 * id 0267D77C-9968-45EF-87FC-CD3368D56383
 * name set-center
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/set-center.svg
 * tags
 * - Database 
 */
export const InnerJoinIcon = SetCenterIcon;
export default InnerJoinIcon